const P2Section2 = () => {
    return (
        <div className="P2Section2">
            <div>
                <h1>Why an IDP?</h1>
                <p>
                    Most science careers don't have a hard-and-fast playbook, and when it comes to graduate school, taking the right courses in the right order doesn't guarantee you success, either in school or beyond.<br/><br/>



                    In order to get what you want out of both your program and your future in science requires deliberate, self-reflective work and intrinsic motivation. The task of developing a clear picture of what you want your future to look like, and then adding colour and depth to that vision to transform it into a workable plan and logical career trajectory can be made much easier by the process of creating an Individual Development Plan (IDP).
                </p>

            </div>
            <img src="GetStartedPageImage.jpg" alt="Get Started Page"></img>   

        </div>
    );
}

export default P2Section2;